import React from 'react';

import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Routes, Route as Ruta } from 'react-router-dom';
import IconBrokers from './imagenes/imagen.png';
import Menu from './Menu';
import ChatBox from './ChatBox';
import ChatSiniestro from './ChatSiniestro';
import ChatGRD from './ChatGRD';
import ChatMatron from './ChatMatron';
import ChatVenta from './ChatVenta';
import ChatNorma from './ChatNorma';
import ChatFAQ from './ChatFAQ';


function App() {
    return (
        <div className="App">
            <header className="App-header">
            <center><img src={IconBrokers} alt="AI Logo" style={{ width: '50px', marginRight: '10px' }} /></center>
                <center><h3>Asistente de seguros</h3></center>
            </header>
            <Router>
                <Routes>
                    <Ruta path="/" element={<Menu />} />
                    <Ruta path="/Chatbox" element={<ChatBox />} />
                    <Ruta path="/Chatsiniestro" element={<ChatSiniestro />} />
                    <Ruta path="/Chatnorma" element={<ChatNorma />} />
                    <Ruta path="/Chatventa" element={<ChatVenta />} />
                    <Ruta path="/Chatgrd" element={<ChatGRD />} />
                    <Ruta path="/Chatfaq" element={<ChatFAQ />} />
                </Routes>
            </Router>
        </div>
    );
}

export default App;
